import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FileText, Code, HelpCircle } from 'lucide-react';

const CategoryTabs = ({ category, scripts = [], articles = [], faqs = [], subcategories }) => {
  const [activeTab, setActiveTab] = useState('scripts');

  return (
    <div>
      <div className="category-tabs">
        <button 
          className={`tab-button ${activeTab === 'scripts' ? 'active' : ''}`}
          onClick={() => setActiveTab('scripts')}
        >
          <Code size={18} />
          Scripts ({scripts.length})
        </button>
        <button 
          className={`tab-button ${activeTab === 'articles' ? 'active' : ''}`}
          onClick={() => setActiveTab('articles')}
        >
          <FileText size={18} />
          Articles ({articles?.length || 0})
        </button>
        <button 
          className={`tab-button ${activeTab === 'faqs' ? 'active' : ''}`}
          onClick={() => setActiveTab('faqs')}
        >
          <HelpCircle size={18} />
          FAQ ({faqs?.length || 0})
        </button>
      </div>

      <div className="tab-content">
        {activeTab === 'scripts' && (
          <div className="section-grid">
            {subcategories.map(subcategory => {
              const subcategoryScripts = scripts.filter(s => s.subcategory === subcategory.name);
              return (
                <div key={subcategory.name} className="section-card">
                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                    <subcategory.icon size={28} color={subcategory.color || "#28a745"} style={{ marginRight: '12px' }} />
                    <h3 className="section-title">{subcategory.name}</h3>
                  </div>
                  <p className="section-description">{subcategory.description}</p>
                  
                  {subcategoryScripts.length > 0 ? (
                    <ul className="script-list">
                      {subcategoryScripts.map(script => (
                        <li key={script.id} className="script-item">
                          <Link to={`/script/${script.id}`} className="script-link">
                            {script.title}
                          </Link>
                          <div style={{ fontSize: '0.85rem', color: '#6c757d', marginTop: '4px' }}>
                            {script.description.substring(0, 100)}...
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p style={{ color: '#6c757d', fontStyle: 'italic' }}>
                      No scripts available in this category yet.
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {activeTab === 'articles' && (
          <div className="articles-grid">
            {articles?.length > 0 ? (
              articles.map(article => (
                <div key={article.id} className="article-card">
                  <div className="article-header">
                    <h3 className="article-title">
                      <Link to={`/article/${article.id}`} className="article-link">
                        {article.title}
                      </Link>
                    </h3>
                    <div className="article-meta">
                      <span>{article.author}</span>
                      <span>{article.readTime}</span>
                      <span>{new Date(article.createdAt).toLocaleDateString()}</span>
                    </div>
                  </div>
                  <p className="article-description">{article.description}</p>
                  <div className="article-category">
                    {article.category} - {article.subcategory}
                  </div>
                </div>
              ))
            ) : (
              <p style={{ color: '#6c757d', fontStyle: 'italic' }}>
                No articles available in this category yet.
              </p>
            )}
          </div>
        )}

        {activeTab === 'faqs' && (
          <div className="faqs-grid">
            {faqs?.length > 0 ? (
              faqs.map(faq => (
                <div key={faq.id} className="faq-card">
                  <div className="faq-header">
                    <h3 className="faq-question">{faq.question}</h3>
                    <div className="faq-meta">
                      <span className={`difficulty-badge ${faq.difficulty?.toLowerCase()}`}>
                        {faq.difficulty}
                      </span>
                      <span>{new Date(faq.createdAt).toLocaleDateString()}</span>
                    </div>
                  </div>
                  <p className="faq-answer">{faq.answer}</p>
                  <div className="faq-category">
                    {faq.category} - {faq.subcategory}
                  </div>
                </div>
              ))
            ) : (
              <p style={{ color: '#6c757d', fontStyle: 'italic' }}>
                No FAQ available in this category yet.
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryTabs;